import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/lib/TranslationsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/authModal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/footer/cmplink.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_infrastructure/ui/components/footer/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/footer/trustpilotwidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/app/src/app/_infrastructure/ui/components/header/LanguageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileMenu"] */ "/app/src/app/_infrastructure/ui/components/header/mobile/menu/MobileMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileSearch"] */ "/app/src/app/_infrastructure/ui/components/header/mobile/MobileSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfileLinks"] */ "/app/src/app/_infrastructure/ui/components/header/ProfileLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/app/src/app/_infrastructure/ui/components/list/breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/multipleimages/desktop/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/multipleimages/mobile/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/pdpquicklinks/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_infrastructure/ui/components/prefetchonhoverlink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccordionDetail"] */ "/app/src/app/_infrastructure/ui/components/product/accordionDetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/product/clickOutButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/product/editorHelper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/product/pdpBackButtonMobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/product/productCoupon/couponlabel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductOverlayHandling"] */ "/app/src/app/_infrastructure/ui/components/product/productOverlayHandling.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/product/productPrice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/product/productTitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RelatedProducts"] */ "/app/src/app/_infrastructure/ui/components/product/relatedProducts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/product/shippingInfo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_infrastructure/ui/components/product/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/sizesmodal/SizesModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchForm"] */ "/app/src/app/_infrastructure/ui/components/subheader/SearchForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToTop"] */ "/app/src/app/_infrastructure/ui/components/totop/toTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetailEvents","PageViewEvents","FbViewContentEvent"] */ "/app/src/app/_infrastructure/ui/components/tracking/events.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_infrastructure/ui/components/tracking/index.tsx");
